export const getNotificationsUnreadCountByCountryId = (
  notificationsUnreadCount: { country_id: string }[],
  countryId: string,
) => {
  const defaultValue = [{ new_count: 0 }];

  if (notificationsUnreadCount && notificationsUnreadCount.length !== 0) {
    const unreadCount = notificationsUnreadCount.filter(item => item.country_id === countryId);

    return unreadCount?.length > 0 ? unreadCount : defaultValue;
  }

  return defaultValue;
};

export const getUnreadTotalCount = (notificationsUnreadCountArray: { new_count: number }[]) => {
  if (!notificationsUnreadCountArray) {
    return 0;
  }

  const total = notificationsUnreadCountArray.reduce((a, b) => a + (b.new_count || 0), 0);

  return total;
};
